import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'react-bootstrap';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import { uploadPrescriptionEvent } from 'Homecare/HomecareAnalytics';
import { IC_UPLOAD_PRESCRIPTION, IC_UPLOAD_PRESCRIPTION_HOMECARE } from '../../Assets/images';
import { HOME_CARE_ROUTE, ONLINE_PHARMACY_ROUTE } from '@common/Utility/constants';
import ButtonBase from '../Forms/ButtonBase/ButtonBase';
import { QuickUploadPrescriptionStyled } from './QuickUploadPrescriptionStyled';
import { getIsInstoreApp, getReferralPageForGA } from '../../Utility/common-utils';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const QuickUploadPrescription = (props) => {
  const { title } = props;
  const [isClient, setIsClient] = useState(false);
  const router = useRouter();
  const generateURL = useNavigationURL();
  const t = useTranslation();
  const referralPageForGa = getReferralPageForGA(router.asPath);
  const navigateToLogin = () => {
    dataLayerSendEvent('upload_prescription', {
      screen_name: router?.pathname?.includes("online-pharmacy") ? 'epharmacy homepage' : 'asco homepage',
      page_type: 'homepage',
      myaster_category: 'epharmacy',
    });
    router.push({ pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/rxupload`) });
  };

  const navigateToHomeCareLogin = () => {
    uploadPrescriptionEvent();
    router.push({ pathname: generateURL(`${HOME_CARE_ROUTE}/rxupload`) });
  };

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient || getIsInstoreApp()) return null;
  return (
    <QuickUploadPrescriptionStyled>
      <Container>
        {!props?.homeCare ? (
          <>
            {title && (
              <div className="titleBar">
                <h2 className="title">{title}</h2>
              </div>
            )}
            <div className="uploadBox">
              <div className="leftArea">
                <div className="ic">
                  <Image src={IC_UPLOAD_PRESCRIPTION} alt="" />
                </div>
                <div className="text">
                  <strong>{t('EPharmacyHome.UploadPrescription')}</strong> <span>{t('EPharmacyHome.medicinesEasily')}</span>
                </div>
              </div>

              <div className="rightArea">
                <Link href={generateURL(`${ONLINE_PHARMACY_ROUTE}/rxupload`)} passHref={true}>
                  <a>
                    <ButtonBase
                      enableFullWidth={false}
                      iconPosition="left"
                      iconWidth="20px"
                      iconHeight="20px"
                      size="sm"
                      variant="outline-success"
                      text="Upload & Order"
                      onClick={navigateToLogin}
                    />
                  </a>
                </Link>
              </div>
            </div>
          </>
        ) : (
          <div className="uploadBox homecare">
            <div className="leftArea">
              <div className="ic">
                <Image src={IC_UPLOAD_PRESCRIPTION_HOMECARE} alt="" />
              </div>
              <div className="text">
                <strong>{t('EPharmacyHome.uploadClaimDocuments')} </strong> <span>&amp; {t('EPharmacyHome.bookInsurance')}</span>
              </div>
            </div>

            <div className="rightArea">
              <Link href={generateURL(`${HOME_CARE_ROUTE}/rxupload`)} passHref={true}>
                <a>
                  <ButtonBase
                    enableFullWidth={false}
                    iconPosition="left"
                    iconWidth="20px"
                    iconHeight="20px"
                    size="sm"
                    variant="outline-success"
                    text="Upload"
                    onClick={navigateToHomeCareLogin}
                  />
                </a>
              </Link>
            </div>
          </div>
        )}
      </Container>
    </QuickUploadPrescriptionStyled>
  );
};

QuickUploadPrescription.propTypes = {
  title: PropTypes.string,
};

export default QuickUploadPrescription;
